import { Outlet, useNavigate } from 'react-router-dom';
import Logo from '../assets/images/logo.svg';
import { useEffect } from 'react';

const AuthLayout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const existingSessionId = localStorage.getItem('sessionId');
    if (existingSessionId) {
      navigate('/dashboard');
    }
  }, [navigate]);

  return (
    <div className="flex items-center justify-center p-5 w-full h-full flex-col">
      <div className="flex justify-center items-center mb-4">
        <img src={Logo} className="w-[35px] h-[35px]" alt="logo" />
        <span className="font-semibold sm:text-[24px]">answerr</span>
      </div>
      <Outlet />
    </div>
  );
};

export default AuthLayout;
